import {Breadcrumbs, FormDialog, Title} from '@management-ui/core';
import * as React from 'react';
import {useCallback, useState} from 'react';
import TableHolder from '../../../../components/TableHolder';
import Table from './Table';
import {Box, Button} from '@mui/material';
import {Add} from '@mui/icons-material';
import {useHistory} from 'react-router-dom';
import {reverse} from 'named-urls';
import routes from '../../../../routes';
import TaskForm from '../../forms/TaskForm';
import {useSelector} from 'react-redux';
import ProgressSummary from './ProgressSummary';

const Tasks = () => {
  const history = useHistory();
  const [showNew, setShowNew] = useState(false);
  const user = useSelector(state => state['auth'].user);
  const [assignee, setAssignee] = useState('');
  const [users, setUsers] = useState([]);

  const goToDetail = useCallback((task) => {
    history.push(reverse(task.archived ? routes.archive.task.detail : routes.tasks.detail, {id: task.id}));
  }, [history]);

  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Tasks'}]}/>
      <Title title="Tasks">
        <Box display="flex" flex={1} justifyContent="flex-end">
          <Button variant="contained" startIcon={<Add/>} onClick={() => setShowNew(true)} color="success">
            Add New Task
          </Button>
        </Box>
      </Title>
      <ProgressSummary users={users} selected={assignee} onSelect={setAssignee}/>
      <TableHolder>
        <Table assignee={assignee} onUpdateUsers={setUsers}/>
      </TableHolder>
      <FormDialog
        title="Add New Task"
        open={showNew}
        onClose={() => setShowNew(false)}
        render={(props) => (
          <TaskForm
            {...props}
            task={{assignee_id: user.id, priority: 'Medium'}}
            onSaved={goToDetail}/>
        )}
      />
    </div>
  );
};

export default Tasks;
